export const PONR_MODAL_TITLE = 'Too late to change online';
export const PONR_MODAL_FIRST_PARAGRPH = 'You can make changes up to 12noon on the day before your appointment. Because that’s passed, we’ll see you tomorrow to get your new service up and running.';
export const PONR_MODAL_SECOND_PARAGRPH = 'It may still be possible to make changes by calling us. However, you may need to pay an ';

export const ABORTIVE_VISIT_CHARGE_LABEL = 'Abortive Visit Charge';
export const ABORTIVE_VISIT_CHARGE_URL = 'https://www.bt.com/pricing/current/Misc_boo/1393_d0e1.htm#1393-d0e1';

export const CONTACT_US_LABEL = 'Contact us';
export const CONTACT_US_URL = 'https://business.bt.com/help/contact-us-business/#checkorder';

export const RETURN_LABEL = 'Stick with booked appointment';
